import { useState, useEffect } from 'react';
import { SummaryTable } from 'src/Components/Organisms';
import Card, { CardContent, CardTitle } from "src/MarketDataComponents/Card";
import Link from 'next/link';
import { format } from './index';

export default function CashFlow({cashFlow, quote}) {

    const [cashFlowFormatted, setCashFlowFormatted] = useState(false);
    const [currency, setCurrency] = useState(null);

    useEffect(() => {
        const cashFlowFormatted = [];
        let cashFlowCurrency = null;

        cashFlow.reverse().forEach((item) => {
            cashFlowCurrency = item.currency;
            cashFlowFormatted.push({
                label: item.yearEnd ? item.yearEnd.split('-')[0] : '',
                values: {
                    operating: format(item.operatingCashFlow),
                    investing: format(item.investingCashFlow),
                    financing: format(item.financingCashFlow),
                    freeCashFlow: format(item.financingCashFlow)
                }
            });
        });

        setCurrency(cashFlowCurrency);
        setCashFlowFormatted(cashFlowFormatted);
    }, []);

    return <>{cashFlowFormatted ? <Card>
        <h2 className="h4 margin-bottom-0" data-testid="cashFlowTableHeader">Cash flow</h2>
        <CardContent>
            <SummaryTable 
                periods={cashFlowFormatted}
                categories={{
                    operating: "Operating",
                    investing: "Investing",
                    financing: "Financing",
                    freeCashFlow: "Free cash flow"
                }}
            />
            <Link href={`/sub/${quote.marketCode}/financials/cash-flow`} data-testid="cashFlowMoreLink">More</Link>
        </CardContent>
    </Card>: null}</>

}
